import {
  LayoutDashboard, Building2, DoorOpen, Users, FileText,
  ClipboardList, Receipt, CreditCard, Smartphone, Zap,
  PiggyBank, Wrench, Truck, ClipboardCheck, BarChart3,
  Timer, Shield, Settings, MessageSquare, DollarSign,
  AlertTriangle, Calendar, MoveRight, TrendingDown,
  Megaphone, Wallet, Hotel, Home, Bell, LogOut, Activity, Inbox, UserCog, Upload,
} from 'lucide-react';

const OWNER_ROLES  = ['superadmin', 'owner', 'manager'];
const ALL_ROLES    = ['superadmin', 'owner', 'manager', 'tenant', 'maintenance'];

export const navItems = [
  // ── Owner / Manager / Superadmin — Main ───────────────────────────────────
  { label:'Dashboard',         path:'/dashboard',    icon:LayoutDashboard, roles:OWNER_ROLES, section:'Main' },
  { label:'Properties',        path:'/properties',   icon:Building2,       roles:OWNER_ROLES, section:'Main' },
  { label:'Units',             path:'/units',        icon:DoorOpen,        roles:OWNER_ROLES, section:'Main' },
  { label:'Tenants',           path:'/tenants',      icon:Users,           roles:OWNER_ROLES, section:'Main' },
  { label:'Staff',             path:'/staff',        icon:UserCog,         roles:['owner','superadmin'], section:'Main' },
  { label:'Bulk Import',       path:'/import',       icon:Upload,          roles:['owner','manager'], section:'Main' },
  { label:'Leases',            path:'/leases',       icon:FileText,        roles:OWNER_ROLES, section:'Main' },
  { label:'Applications',      path:'/applications', icon:ClipboardList,   roles:OWNER_ROLES, section:'Main' },
  { label:'Vacate Notices',    path:'/vacate-notices',icon:LogOut,         roles:OWNER_ROLES, section:'Main' },
  { label:'Vacancy Listings',  path:'/vacancy-listings',icon:Home,         roles:OWNER_ROLES, section:'Main' },

  // ── Financial ──────────────────────────────────────────────────────────────
  { label:'Invoices',          path:'/invoices',     icon:Receipt,         roles:OWNER_ROLES, section:'Financial' },
  { label:'Payments',          path:'/payments',     icon:CreditCard,      roles:OWNER_ROLES, section:'Financial' },
  { label:'M-Pesa Logs',       path:'/mpesa-logs',   icon:Smartphone,      roles:OWNER_ROLES, section:'Financial' },
  { label:'Expenses',          path:'/expenses',     icon:TrendingDown,    roles:OWNER_ROLES, section:'Financial' },
  { label:'Budgets',           path:'/budgets',      icon:Wallet,          roles:OWNER_ROLES, section:'Financial' },
  { label:'Utility Bills',     path:'/utilities',    icon:Zap,             roles:OWNER_ROLES, section:'Financial' },
  { label:'Security Deposits', path:'/deposits',     icon:PiggyBank,       roles:OWNER_ROLES, section:'Financial' },

  // ── Operations ─────────────────────────────────────────────────────────────
  { label:'Maintenance',       path:'/maintenance',  icon:Wrench,          roles:['superadmin','owner','manager','maintenance'], section:'Operations' },
  { label:'Vendors',           path:'/vendors',      icon:Truck,           roles:OWNER_ROLES, section:'Operations' },
  { label:'Inspections',       path:'/inspections',  icon:ClipboardCheck,  roles:OWNER_ROLES, section:'Operations' },
  { label:'Short-term Rentals',path:'/short-term',   icon:Hotel,           roles:OWNER_ROLES, section:'Operations' },

  // ── Communications ─────────────────────────────────────────────────────────
  { label:'Messages',          path:'/messages',     icon:MessageSquare,   roles:ALL_ROLES,   section:'Communications' },
  { label:'Announcements',     path:'/announcements',icon:Megaphone,       roles:OWNER_ROLES, section:'Communications' },

  // ── Analytics ──────────────────────────────────────────────────────────────
  { label:'Reports & Analytics',path:'/analytics',   icon:BarChart3,       roles:OWNER_ROLES, section:'Analytics' },
  { label:'Collections Aging', path:'/collections',  icon:Timer,           roles:OWNER_ROLES, section:'Analytics' },
  { label:'Alert Rules',       path:'/alert-rules',  icon:Bell,            roles:OWNER_ROLES, section:'Analytics' },
  { label:'Audit Log',         path:'/audit-logs',  icon:Activity,        roles:['superadmin'], section:'System' },

  // ── System ─────────────────────────────────────────────────────────────────
  { label:'Prospects',         path:'/prospects',    icon:Inbox,           roles:['superadmin'], section:'System' },
  { label:'Platform',          path:'/platform',     icon:Building2,       roles:['superadmin'], section:'System' },
  { label:'User Management',   path:'/users',        icon:Shield,          roles:['superadmin'], section:'System' },
  { label:'Settings',          path:'/settings',     icon:Settings,        roles:ALL_ROLES,   section:'System' },

  // ── Tenant only ────────────────────────────────────────────────────────────
  { label:'My Lease',          path:'/my-lease',         icon:FileText,      roles:['tenant'], section:'Main' },
  { label:'Payment History',   path:'/payment-history',  icon:DollarSign,    roles:['tenant'], section:'Main' },
  { label:'Report Issue',      path:'/report-issue',     icon:AlertTriangle, roles:['tenant'], section:'Main' },
  { label:'My Requests',       path:'/my-maintenance',   icon:Wrench,        roles:['tenant'], section:'Main' },
  { label:'Notice to Vacate',  path:'/notice-to-vacate', icon:MoveRight,     roles:['tenant'], section:'Main' },

  // ── Maintenance staff only ─────────────────────────────────────────────────
  { label:'My Tasks',          path:'/my-tasks',     icon:Wrench,          roles:['maintenance'], section:'Main' },
  { label:'Work Schedule',     path:'/schedule',     icon:Calendar,        roles:['maintenance'], section:'Main' },
];

export function getNavItemsByRole(role) {
  if (!role) return [];
  return navItems.filter(item => item.roles.includes(role));
}

export function getNavSectionsByRole(role) {
  const items = getNavItemsByRole(role);
  const sections = {};
  items.forEach(item => {
    if (!sections[item.section]) sections[item.section] = [];
    sections[item.section].push(item);
  });
  return sections;
}

export function getRoleHomePath(role) {
  switch (role) {
    case 'tenant':      return '/my-lease';
    case 'maintenance': return '/my-tasks';
    default:            return '/dashboard';
  }
}